import { Link } from '@mui/material';
import { ActionPopover } from 'components/ActionPopover';
import { TableV2Column } from 'components/Table/TableV2';
import { SourcedCandidateQueryItem } from 'modules/sourcing-external/types/SourcedCandidateQueryItem';

type GetSourcingExternalSelectedCandidatesColumnsProps = {
  handleViewDetails: (row: SourcedCandidateQueryItem, index: number) => void;
  handleRemove: (row: SourcedCandidateQueryItem) => void;
};

export const getSourcingExternalSelectedCandidatesColumns = ({
  handleViewDetails,
  handleRemove
}: GetSourcingExternalSelectedCandidatesColumnsProps): TableV2Column<SourcedCandidateQueryItem>[] => [
  {
    name: 'Name',
    selector: (row) => row.fullName || '',
    sortable: true,
    minWidth: '180px',
    cell: (row: SourcedCandidateQueryItem, index: number) => (
      <Link
        onClick={() => handleViewDetails(row, index)}
        sx={{ cursor: 'pointer' }}
      >
        {row.fullName || ''}
      </Link>
    ),
    id: 'name'
  },
  {
    name: 'Location',
    selector: (row) => row.location || '',
    sortable: true,
    minWidth: '140px',
    id: 'location'
  },
  {
    name: 'Current Role',
    selector: (row) => row.title || '',
    sortable: true,
    minWidth: '180px',
    id: 'currentRole'
  },
  {
    name: '',
    isAction: true,
    minWidth: '120px',
    cell: (row: SourcedCandidateQueryItem, index: number) => (
      <ActionPopover
        id={`invite-candidate-action-${row.id}`}
        options={[
          {
            label: 'View details',
            onClick: () => handleViewDetails(row, index)
          },
          {
            label: 'Remove',
            onClick: () => handleRemove(row),
            itemColor: 'error.main'
          }
        ]}
      />
    ),
    id: 'action'
  }
];
